import { ThemeSettings } from './theme/Theme';
import RTL from './layouts/full/shared/customizer/RTL';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router';
import router from './routes/Router';
import { SnackbarProvider } from 'notistack';
import { useAppSelector } from './store';
import Toaster from './components/Toaster';
import Common from './components/Common';
import 'react-quill-new/dist/quill.snow.css';
import './app.scss';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import { ruRU } from '@mui/x-date-pickers/locales';
import { enUS } from '@mui/x-date-pickers/locales';

function App() {
  const theme = ThemeSettings();
  const customizer = useAppSelector((state) => state.customizer);
  const lang = useAppSelector((state) => state.site.lang);

  const curLocale = lang == 'ru' ? ruRU : enUS;

  return (
    <ThemeProvider theme={theme}>
      <RTL direction={customizer.activeDir}>
        <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={lang}
            localeText={curLocale.components.MuiLocalizationProvider.defaultProps.localeText}>
            <CssBaseline />
            <RouterProvider router={router} />
            <Toaster />
            <Common />
          </LocalizationProvider>
        </SnackbarProvider>
      </RTL>
    </ThemeProvider>
  );
}

export default App;
